import React from 'react';

import {
  MessageType,
  NoEntitiesMessage,
} from 'client/app/apps/experiments/NoEntitiesMessage';

type Props = {
  searchQuery?: string;
};

const ProtocolsListNoDataComponent = ({ searchQuery }: Props) => {
  return (
    <NoEntitiesMessage
      entityName="protocols"
      messageType={MessageType.NO_FILTER_RESULTS}
      searchQuery={searchQuery}
    />
  );
};

export default ProtocolsListNoDataComponent;
